export const ACCESS_TOKEN = 'kct_admin_access_token';
export const REFRESH_TOKEN = 'kct_admin_refresh_token';
export const USER_INFO = 'kct_admin_user_info';
export const USER_ROLE = 'kct_admin_user_role';

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);

export const setToken = (accessToken, refreshToken) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};

export const setUserInfo = (userInfo) => {
  localStorage.setItem(USER_INFO, JSON.stringify(userInfo));
};

export const getUserInfo = () => {
  const info = localStorage.getItem(USER_INFO);
  return info ? JSON.parse(info) : null;
};

export const getUserRole = () => {
  return localStorage.getItem(USER_ROLE) || getUserInfo()?.role || '';
};

export const setUserRole = (role) => {
  localStorage.setItem(USER_ROLE, role);
};

export const isTokenExpired = () => {
  const token = getAccessToken();
  if (!token) return true;
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return true;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(
      (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join('')));
    const exp = payload.exp;
    if (!exp) return false;
    return Date.now() >= exp * 1000;
  } catch {
    return false;
  }
};

export const clearAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(USER_INFO);
  localStorage.removeItem(USER_ROLE);
};
